/**
 * @generated SignedSource<<0c679e0018346be6c2b20c2cf821164d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type FirstGroupIssues$data = {
  readonly fieldId: string | null | undefined;
  readonly " $fragmentType": "FirstGroupIssues";
};
export type FirstGroupIssues$key = {
  readonly " $data"?: FirstGroupIssues$data;
  readonly " $fragmentSpreads": FragmentRefs<"FirstGroupIssues">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "FirstGroupIssues",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "fieldId"
    }
  ],
  "type": "JiraJqlFieldWithAliases"
};

(node as any).hash = "07fdb734208e30b5f6168c7a0d56cad5";

export default node;
